export const setCurrency = (lenguageData) => {
  return {
    type: 'SET_CURRENCY',
    payload: lenguageData,
  };
};

export const clearCurrency = () => ({
  type: 'CLEAR_CURRENCY',
});
